import styled from 'styled-components'
import Flex from '../../../../components/Flex'
import { COLORS } from 'theme'

export const Container = styled(Flex)`
  display: flex;
  flex-direction: row;
  //  width: 100%;
  margin-left: 15px;
  position: relative;
`
export const ToggleContainer = styled(Flex)`
  width: fit-content;
  justify-content: center;
  align-items: center;
  padding: 3px 4px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  cursor: pointer;
  position: relative;
`
export const CommonToggle = styled.div`
  padding: 0.3rem 0.7rem;
  color: ${props => props.color};
  background: ${props => props.background} !important;
  border-radius: 8px;
  transition: 0.5s;
  z-index: 1;
  position: relative;
`

export const LabelDiv = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  letter-spacing: 0.01em;
  padding-left: -20px;
  padding-top: 13px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 18.51px;
`

export const FilterFolderRelative = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
export const FilterFolderAbsolute = styled.div`
  z-index: 9;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  padding-top: 9px;
  color: ${props => props.disabled && '#939393'};
`
export const FilterFolderAbsolute1 = styled.div`
  z-index: 9;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  color: ${props => props.disabled && '#939393'};
`
export const RightSticky = styled(Flex)`
  justify-content: flex-end;
  gap: 20px;
  padding-right: 20px;
  position: relative;
`
export const FilterLabel = styled.p`
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  white-space: ${props => (props.whiteSpace ? props.whiteSpace : '')};
`
